var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegistration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.482,
    height: 32.65,
    viewBox: "0 0 25.482 32.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Registration_No",
    "data-name": "Registration No",
    d: "M171.928,181.83a.825.825,0,0,0-.722.8v2.787h-2.862a.825.825,0,0,0-.722.8v27.473a.827.827,0,0,0,.8.8h20.306a.827.827,0,0,0,.8-.8V210.9h2.787a.827.827,0,0,0,.8-.8V182.626a.827.827,0,0,0-.8-.8H171.928Zm.871,1.592h18.714V209.3H172.8C172.8,200.679,172.8,192.03,172.8,183.422Zm-3.584,3.583h1.991V210.1a.828.828,0,0,0,.8.8h15.926v1.991H169.215Zm7.092,0a.8.8,0,1,0,.075,1.593h2.787a.8.8,0,1,0,0-1.593h-2.862Zm6.371,0a.8.8,0,1,0,.075,1.593h5.972a.8.8,0,1,0,0-1.593h-6.047Zm-6.371,3.185a.8.8,0,1,0,.075,1.593h2.787a.8.8,0,1,0,0-1.593h-2.862Zm6.371,0a.8.8,0,1,0,.075,1.593h5.972a.8.8,0,1,0,0-1.593h-6.047Zm-6.371,6.769a.8.8,0,1,0,.075,1.592h2.787a.8.8,0,1,0,0-1.593h-2.862Zm6.371,0a.8.8,0,1,0,.075,1.592h5.972a.8.8,0,1,0,0-1.593h-6.047Zm-6.371,3.185a.8.8,0,1,0,.075,1.592h2.787a.8.8,0,1,0,0-1.593h-2.862Zm6.371,0a.8.8,0,1,0,.075,1.592h5.972a.8.8,0,1,0,0-1.593h-6.047Z",
    transform: "translate(-167.623 -181.83)",
    fill: "#ff7200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistration);
export default __webpack_public_path__ + "static/media/registration.9303d598244d83277014f91a6071f0c0.svg";
export { ForwardRef as ReactComponent };